import { Box } from '@quintoandar-tokko/jopijs';
import styles from './performanceModals.module.scss';

export default function TableContainer({ children }) {
  return <Box className={styles.modalBodyTableContent}>{children}</Box>;
}
